import { COLOR } from '../../helpers/colors';

export const textBoxStyle = {
  border: `1px solid ${COLOR.borderColor}`,
  borderRadius: 0.5,
  width: '100%',
  pt: 1,
  pb: 1,
  pl: 1.5,
  pr: 1.5,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};
